export const currentWorkshop = state => state.workshops.currentWorkshop

export const workshops = state => state.workshops.list
